import { SET_ERROR } from '../mutations/common.mutations';
import { FETCH_PAGES } from '../actions/page.actions';
import { SET_PAGES, SET_SELECTED_PAGE, TRY_FETCH_PAGES } from '../mutations/page.mutations';
import PageService from '../../common/services/page.service';
import { getError } from '@/common/services/http.service';

const state = {
  pending: false,
  errors: [],
  user: null,
  pages: [],
  loaded: false,
  selectedPage: null
};

const actions = {
  [FETCH_PAGES](context) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_FETCH_PAGES);

      PageService.getPages()
        .then(data => {
          context.commit(SET_PAGES, data.pages);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          reject('Error loading pages');
        });
    });
  },
};

const mutations = {
  [TRY_FETCH_PAGES](state) {
    state.pending = true;
    state.errors = [];
  },
  [SET_ERROR](state, errors) {
    state.pending = false;
    state.errors = errors;
  },
  [SET_PAGES](state, pages) {
    state.pending = false;
    state.errors = [];
    state.pages = pages;
    state.loaded = true;
  },
  [SET_SELECTED_PAGE](state, page) {
    state.selectedPage = page;
  },
};

const getters = {
  pages: state => {
    return state.pages
  },
  getPageBySlug: state => slug => {
    return state.pages.find(page => page.slug === slug);
  },
  pagesLoaded: state => {
    return state.loaded;
  },
  pagesPending: state => {
    return state.pending;
  },
  selectedPage: state => {
    return state.selectedPage;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
